import { useEffect, useState, type ReactNode } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { REPORT_ISSUE_URL, REQUEST_TOOL_URL } from '../config';
import { tools } from '../data/tools';
import { trackFeedbackRequestClicked, trackIssueReportClicked } from '../lib/analytics';

export function AppShell({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <div className="app-shell">
      <aside className={open ? 'sidebar mobile-open' : 'sidebar'}>
        <div className="sidebar-top">
          <Link className="brand" to="/" aria-label="PrivateFileKit home">
            <div className="logo">PF</div>
            <div>
              <strong>PrivateFileKit</strong>
              <span>Private file tools</span>
            </div>
          </Link>
          <button className="mobile-tools-button" type="button" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="tools-navigation">
            Tools <span aria-hidden="true">{open ? '×' : '☰'}</span>
          </button>
        </div>
        <div className="nav-title">Tools</div>
        <nav className="nav-list" id="tools-navigation" aria-label="Tool navigation">
          {tools.map((tool) => (
            <NavLink key={tool.to} to={tool.to} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
              <i>{tool.icon}</i>
              <span>
                {tool.name}
                <small>{tool.detail}</small>
              </span>
            </NavLink>
          ))}
        </nav>
        <div className="privacy-card">
          <strong>Files stay on your device</strong>
          <span>Processing happens in this browser tab. No account and no file storage.</span>
        </div>
      </aside>
      {open && <button className="mobile-menu-backdrop" aria-label="Close tools menu" onClick={() => setOpen(false)} />}
      <div className="content-column">
        <main className="main-content">{children}</main>
        <footer className="site-footer">
          <span>PrivateFileKit</span>
          <nav aria-label="Footer">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <a
              href={REQUEST_TOOL_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Request a new file tool in a new tab"
              onClick={() => trackFeedbackRequestClicked('footer')}
            >
              Request a tool
            </a>
            <a
              href={REPORT_ISSUE_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Report an issue in a new tab"
              onClick={() => trackIssueReportClicked('footer')}
            >
              Report an issue
            </a>
          </nav>
          <span>Browser-based file tools</span>
        </footer>
      </div>
    </div>
  );
}
